import type { FrontDoorRole } from "@/lib/modules/auth/front-door/types";

/** The role pills, in the order they appear. */
export const FRONT_DOOR_ROLES: { role: FrontDoorRole; label: string }[] = [
  { role: "SCHOOL_WORKER", label: "School Worker" },
  { role: "GUARDIAN", label: "Guardian" },
  { role: "PATIENT", label: "Patient" },
  { role: "THERAPIST", label: "Therapist" },
  { role: "HEALTH_PLAN", label: "Health Plan Employee" },
  { role: "PEDIATRICIAN", label: "Pediatrician or PCP" },
];

/** Families sign in with a one-time code and refer instead of signing up. */
export const FRONT_DOOR_FAMILY_ROLES: FrontDoorRole[] = ["GUARDIAN", "PATIENT"];

export const FRONT_DOOR_CAREERS_URL = "https://marblehealth.com/careers";

export const FRONT_DOOR_PROVIDERS_EMAIL = "providers@marblehealth.com";

/** The title above the card, the same for every role and tab. */
export const FRONT_DOOR_HEADING = {
  title: "Welcome to Marble Health!",
};

/**
 * Query params the front door reads for sign-in or sign-up itself. Its Refer
 * buttons pass every other param (UTM tags, a `schoolId` link) on to `/refer`,
 * as the old home page did.
 */
export const FRONT_DOOR_ONLY_PARAMS: readonly string[] = [
  "callbackUrl",
  "sessionExpired",
  "isInsurancePayer",
  "token",
  "userId",
  "therapistId",
  "type",
];
